import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {AuthUser, User, UserFormData} from '../../models/user';

export const currentUser = async (client: AxiosInstance) =>
    responseHandler<AuthUser>(client.get('/auth/currentUser'))

/** A one-hour sign-in token for the current user, to carry the session to the app subdomain. */
export const handoffToken = async (client: AxiosInstance) =>
    responseHandler<{ firebaseToken: string }>(client.get('/auth/handoffToken'))

export const logout = async (client: AxiosInstance) =>
    responseHandler<void>(client.get('/auth/logout'))

export const register = async (client: AxiosInstance, userFormData: UserFormData) =>
    responseHandler<AuthUser>(client.post('/auth/register', userFormData))

export const authenticateWithProvider = async (client: AxiosInstance, idToken: string) =>
    responseHandler<AuthUser>(client.post('/auth/authenticateWithProvider', {idToken}))